/**
 * TypeScript projections of /contracts/openapi/identity.yaml schemas.
 * Hand-maintained against contract v1.1.0 — any drift is a review blocker
 * (§16.2: contracts are the interface, owner: core-agent).
 */

export type ClientType = "ADMIN_WEB" | "MERCHANT_APP" | "DRIVER_APP" | "CUSTOMER_APP" | "PUBLIC_API";

export type UserStatus = "PENDING_VERIFICATION" | "ACTIVE" | "SUSPENDED" | "DELETED";

export interface TokenPair {
  readonly access_token: string;
  readonly token_type: "Bearer";
  /** Access-token TTL seconds (System Setting, default 15 min). */
  readonly expires_in: number;
  /**
   * Opaque, single-use — rotated on every refresh. Never logged (§11.1).
   * v1.1.0: OMITTED for ADMIN_WEB — the refresh token travels ONLY as the
   * httpOnly `refresh_token` cookie on /api/v1/auth; this client never sees it.
   */
  readonly refresh_token?: string;
}

export interface User {
  readonly id: string;
  readonly phone: string;
  readonly name: string;
  readonly email?: string | null;
  readonly status: UserStatus;
  readonly preferred_locale: "ar" | "en";
  readonly phone_verified: boolean;
  readonly created_at: string;
}

export interface RoleAssignment {
  readonly role_key: string;
  readonly scope_type: "GLOBAL" | "MERCHANT" | "BRANCH";
  readonly scope_id: string | null;
}

export interface Me extends User {
  readonly roles: ReadonlyArray<RoleAssignment>;
  /** Effective permission keys (union across scoped roles) — drives RBAC hiding (§11.1). */
  readonly permissions: ReadonlyArray<string>;
}

export interface AuthResult {
  readonly user: User;
  readonly tokens: TokenPair;
  readonly is_new_user: boolean;
}

/** E.164 (identity.yaml `Phone` schema). */
export const PHONE_PATTERN = /^\+[1-9][0-9]{7,14}$/;

export const PASSWORD_MIN_LENGTH = 8;
